/* Copyright IBM Corp. 2018 */
import { noop } from './../misc';

/**
 * Logger that really does not log anything
*/
export const NOOP_LOGGER = {
    'info': noop,
    'warn': noop,
    'error': noop
};

